import { render, staticRenderFns } from "./ProductsDetail.vue?vue&type=template&id=d5dc04b4&scoped=true&"
import script from "./ProductsDetail.vue?vue&type=script&lang=js&"
export * from "./ProductsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDetail.vue?vue&type=style&index=0&id=d5dc04b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5dc04b4",
  null
  
)

export default component.exports